<template>
  <div class="cancelOfOrder">
    <el-dialog
      title="取消订单"
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      width="50%"
      class="dialog"
      center
    >
      <el-alert
        title="取消订单之后将直接给用户退款，请谨慎操作！！！ "
        type="error"
        :closable="false"
      >
      </el-alert>
      <div class="contents deadline">
        <el-form
          :model="cityForm"
          :rules="cityrules"
          ref="cityForm"
          label-width="170px"
          class="demo-cityForm"
        >
          <el-form-item label="变更用户手机号" prop="mobile">
            <div>
              <el-input
                v-model="cityForm.mobile"
                placeholder="请输入变更用户手机号"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="订单编号" prop="order_no">
            <div>
              <el-input
                v-model="cityForm.order_no"
                placeholder="请输入订单编号"
                clearable
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item label="变更原因" prop="reason">
            <div>
              <el-input
                v-model="cityForm.reason"
                maxlength="200"
                show-word-limit
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="请输入变更原因"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="变更证据" prop="reason_img">
            <el-upload
              element-loading-text="正在上传..."
              action="#"
              :on-preview="handlePictureCardPreview"
              :class="{ hide: url.length == 5 }"
              :file-list="url"
              list-type="picture-card"
              :http-request="
                (file) => {
                  return uploadFile(file, 'url');
                }
              "
              :before-remove="
                (file, fileList) => {
                  return deleteFile(file, fileList, 'url');
                }
              "
              :limit="5"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="cancelOfOrder">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
    
    <script>
export default {
  data() {
    return {
      centerDialogVisible: false,
      url: [],
      cityForm: {
        order_id: "", //	number	订单id
        order_no: "", //	string	订单号
        mobile: "", //	string	用户手机号
        reason: "", //	string	原因 最大200字
        reason_img: [],
      },
      option: [],
      cityrules: {
        order_no: [
          { required: true, message: "请输入订单编号", trigger: "blur" },
        ],
        reason: [
          { required: true, message: "请输入变更原因", trigger: "blur" },
        ],
        reason_img: [
          {
            type: "array",
            required: true,
            message: "请至少上传一张变更证据",
            trigger: "change",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入变更用户手机号",
            // blur和change事件触发检验
            trigger: ["blur", "change"],
          },
          // 正则判断为字母或数字
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            // 正则检验前先将值转为字符串
            transform(value) {
              return String(value);
            },
            message: "该手机号码不符合规范",
            trigger: ["blur"],
          },
        ],
      },
    };
  },

  methods: {
    handlePictureCardPreview(file) {
      console.log("object", file);
      //   this.bigImage = file.url;
      //   this.dialogImage = true;
    },
    uploadFile(options, name) {
      // 拿到 file
      let file = options.file;
      let date = new Date().getTime();
      console.log(file, "文件");
      var event = event || window.event;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        this.uploadImage(e.target.result, name);
      };
    },
    uploadImage(img, name) {
      this.$api.general.uploadImage({ file_data: img }).then((res) => {
        this.url.push({ url: res.data });
        this.cityForm.reason_img.push(res.data);
      });
    },
    deleteFile(file, fileList, name) {
      this.url = fileList;
      this.cityForm.reason_img = fileList.map((el) => el.url);
    },
    hqinfo(e) {
      this.cityForm = {
        order_id: "", //	number	订单id
        order_no: "", //	string	订单号
        mobile: "", //	string	用户手机号
        reason: "", //	string	原因 最大200字
        reason_img: [],
      };
      this.url=[];
      this.cityForm.order_id = e.id;
      this.centerDialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.cityForm.resetFields();
      })
    },

    cancelOfOrder() {
      this.$refs.cityForm.validate((valid) => {
        if (valid) {
          this.$api.general.orderdplatformcancel(this.cityForm).then((res) => {
            this.$emit("cancelOfOrder");
            this.centerDialogVisible = false;
            this.$message({
              type: "success",
              message: "取消成功",
            });
          });
        }
      });
    },
  },
};
</script>
    
    <style lang="scss">
.cancelOfOrder {
  .hide {
    .el-upload--picture-card {
      display: none;
    }
  }
}
</style>